import { CSSProperties, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  as?: keyof HTMLElementTagNameMap;
  style?: CSSProperties;
  className?: string;
}

export function Ellipsis(props: Props) {
  const { children, className, style, as: Component = 'span' } = props;

  return (
    <Component
      className={className}
      style={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'block',
        ...style,
      }}
    >
      {children}
    </Component>
  );
}
